<template>
    <div id="FHUTExceptionList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                 <div class="page-name">
                     <div class="page-title"> FHUT Exception Lists</div>
                    <button type="submit" class="btn btn-primary pull-right" v-on:click.prevent="openModal()"><i class="fp-add"> </i>  Add</button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content charge-list">
                        <data-table-filter-config :moduleName="'FHUTExceptionList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'FHUTExceptionList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                        id="FHUTExceptionListTable"
                                        ref="FHUTExceptionsList"
                                        mode="remote"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        title="FHUT Exception List"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"
                                        :paginationOptions="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                         }"
                                         :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                    >
                                    <div slot="selected-row-actions">
                                          <button v-if="canDelete" id="deleteBillRevJEDetail" v-on:click.prevent="deleteFHUTExceptionConfirm" class="btn btn-primary">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="modal fade make-bill-date-modal" id="fhutExceptionModal" ref="fhutExceptionModal" data-backdrop="static" data-keyboard="false" aria-labelledby="makePaymentModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Add FHUT Exception</h5>
                    <button type="button" class="close" id="btnModalClose" v-on:click="hideModal()">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="form-row">
                            <div class="col-6 form-group">
                                <label class="control-label require" for="customer_id">Customer:</label>
                                <v-select v-model="customerId" name="customer_id" id="customer_id" label="text" :filterable="false" :options="primeCustomerArr" @search="onSearchCustomer" @input="onCustomerChange" placeholder="Select Customer" class='custom-ci-auto-search close-remove' >
                                    <template slot="no-options">
                                        Search Customer...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="field-error">{{ customerErrorMsg }}</div>
                            </div>

                        <div class="col-6 form-group">
                            <label class="control-label require" for="vehicle_pool_id">Asset Pool:</label>
                            <v-select v-model="vehiclePoolId" name="vehicle_pool"
                              placeholder="Select Vehicle Pool."
                              label="text"
                              :options="assetPoolArr" id="vehicle_pool" @input="onChangeVehiclePool($event)">
                             </v-select>
                            <div class="field-error" v-fp-html="assetPoolError"></div>
                        </div>
                        <div class="field-error" v-fp-html="exceptionExistError"></div>
                        <div class="field-success" v-fp-html="fhutExceptionCreatedMsg"></div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" id="btnBillRevJeHeaderAdd" v-on:click="addFHUTException()"> Save </button>
                    <button class="btn btn-primary" id="btnBillRevJeHeaderAdd" v-on:click="addFHUTException('continue')"> Save & Continue</button>
                    <button class="btn btn-tertiary" id="btnBillRevJeHeaderModalCancel" v-on:click="hideModal()"> Cancel </button>
                </div>
            </div>
        </div>
    </div>
    </div>


</template>

<script>


    import Vue from 'vue';
    import EventBus from ".././event-bus";

    import LoadingContent from "@/components/LoadingContent.vue";
    Vue.component("loading-content", LoadingContent);

    import VueSSE from 'vue-sse'
    Vue.use(VueSSE);

    import 'vue-good-table/dist/vue-good-table.css';
    import VueGoodTable from 'vue-good-table';
    Vue.use(VueGoodTable);

    import {commonMixins} from '../../mixins/commonMixins';
    import {contractMixins} from '../../mixins/contractMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    let msgServer
    export default {
        name: "FHUT Exception List",
        components: {
            customPagination: () => import('@/components/layout/CustomPagination'),
            dataTableFilterConfig: () => import('@/components/DataTableFilterConfig'),
            clearCacheData: () => import('@/components/ClearCacheData'),
            appFooter: () => import('@/components/Footer'),
        },
        metaInfo() {
            return {title: "FHUT Exception List | FleetPro Application"}
        },
        mixins:[commonMixins,dataTableMixins,contractMixins],
        data: () => ({

            firstLoad : 0,
            customerId : "",
            primeCustomerArr: [],
            customerErrorMsg: "",
            vehiclePoolId: "",
            assetPoolArr: [],
            assetPoolError: "",
            exceptionExistError: "",
            fhutExceptionCreatedMsg:"",
            flag : "",
            userColumns:[],
            columns: [
                {
                    label: 'Customer',
                    field: 'customer_name',
                    html: true,
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Customer Code',
                    field: 'customer_code',
                    html: true,
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Vehicle Pool',
                    field: 'asset_pool',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Vehicle Pool", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created By',
                    field: 'created_by',
                    hidden:false,
                    filterable: false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Created By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    filterable: false,
                    fpFieldType: "date",
                    hidden: false,
                    filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            permissions:[],
            loading:false,
            hidden:true,
            cantAccessPage:"",
            canAdd:false,
            canUpdate:false,
            batchId: "",
            batchProcess1:false,
            batchNum1:'',
            batchProcess2:false,
            batchNum2:'',
            batchNum3:'',
            createBillRevJEMsg:'',
            postBillRevJEMsg:'',
            action:'',
            subSystemFlag:"",
            subSystemInvArr:[],
            batchError:false,
            batchErrorMsg:"",
            canDelete: false,
            canPost: false,
        }),
        watch:{
            customerId:function(){
                if(this.customerId != null && this.customerId != ''){
                    this.customerErrorMsg = '';
                }
            },
            vehiclePoolId:function(){
                if(this.vehiclePoolId != null && this.vehiclePoolId != ''){
                    this.assetPoolError = '';
                }
            },
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_fhut_exception') {
                        self.cantAccessPage = true;
                    }
                    if(permissions.name == 'add_fhut_exception') {
                        self.canAdd = true;
                    }
                    if(permissions.name == 'delete_fhut_exception') {
                        self.canDelete = true;
                    }
                });
                if(self.cantAccess == ''){
                    self.cantAccess = false;
                }
            }
        },
        created: function() {
            this.serverParams.sort = {field:"id",type:"desc"};
        },
        mounted: function () {
            var self = this;
            self.getPermissions();
            self.loadFieldData(['vehicle_pool']);

        },
        beforeDestroy() {
            msgServer.close();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.FHUTExceptionsList.unselectAllInternal();
            },
            openModal: function(){
                var self = this;
                self.vehiclePoolId = "";
                self.customerId = "";
                self.customerErrorMsg = "";
                self.assetPoolError = "";
                self.exceptionExistError = "";
                $("#fhutExceptionModal").modal("show");
            },
            hideModal: function(){
                if(this.flag == 'continue'){
                    this.loadList();
                }
                this.flag = '';
                $("#fhutExceptionModal").modal("hide");
            },
            onSearchCustomer(search, loading) {
                var self = this;

                // use this in order to create new customer...
                self.searchedCustomer = search;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'primeCustomer', '');
                } else {
                    self.isCustomerNotFound = false;
                }
            },
            onCustomerChange() {
                var self = this;
                console.log('newCustomer removed from localStorage')
                localStorage.removeItem('newCustomer');
                if (self.customerId != null && self.customerId.value != null) {
                    self.getLaborCostValue();
                }
            },
            onChangeVehiclePool() {
                var self = this;
                self.assetPoolError = "";
            },
            addFHUTException: function(flag){
                var self = this;
                var error = false;
                self.action = 'add_fhut_exception';
                if (!self.customerId || self.customerId == null || self.customerId == "") {
                    self.customerErrorMsg = "Customer is Required.";
                    error = true;
                }

                if (!self.vehiclePoolId || self.vehiclePoolId == null || self.vehiclePoolId == "") {
                    self.assetPoolError = "Asset Pool is Required.";
                    error = true;
                }

                if(!error){
                    $.ajax({
                        url: process.env.ROOT_API + "/fhut-exception/create",
                        type: "POST",
                        headers: this.ajxHeaders,
                        dataType: "json",
                        data:{
                            customerId: self.customerId.value,
                            vehiclePoolId: self.vehiclePoolId.value,
                        },
                        success: function (data) {
                            if(data.status == 'success'){
                                self.vehiclePoolId = "";
                                self.customerId = "";
                                self.customerErrorMsg = "";
                                self.assetPoolError = "";
                                self.exceptionExistError = "";
                                console.log('exp error = ' , self.exceptionExistError);
                                if(flag == 'continue'){
                                    self.flag = 'continue';
                                    self.fhutExceptionCreatedMsg = "FHUT Exception Created.";
                                    setTimeout(() => {
                                        self.fhutExceptionCreatedMsg = "";
                                    }, 2000);
                                }else{
                                    self.hideModal();
                                    self.$swal('', 'FHUT Exception Created', 'success');
                                    EventBus.$emit('clear-all-flags', false);
                                    self.loadList();
                                    return;
                                }
                            }

                            if(data.status == 'already exisits'){
                                self.exceptionExistError = 'This Exception Already Exists';
                            }

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            },

            loadList: function(){
                var self = this;
                self.loading = true;

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                };

                $.ajax({
                    url: process.env.ROOT_API + "/fhut-exception/list",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:fields,
                    success: function (data) {
                        self.loading = false;
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            deleteFHUTExceptionConfirm: function(){
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete these FHUT Exceptions?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.deleteFHUTException();
                    }
                });
            },
            deleteFHUTException: function(){
                var self = this;
                var data = this.$refs['FHUTExceptionsList'].selectedRows;
                var idArr = [];
                for (var i = 0; i < data.length; i++) {
                    idArr.push(this.$refs['FHUTExceptionsList'].selectedRows[i].id);
                }
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/fhut-exception/delete",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        idArr: idArr,
                    },
                    success: function (data) {
                        self.loading = false;

                        if(data.status == 'success'){
                            self.$swal('', 'FHUT Exceptions Deleted', 'success');
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }

                        if(data.status == 'error'){
                            self.$swal('',data.message,data.status);
                            EventBus.$emit('clear-all-flags', false);
                            self.loadList();
                            return;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/invoice/FHUTExceptionList.vue